export enum LimitOrder {
  OPTIONAL = 'optional',
  NO_LIMIT = 'nolimit'
}
